import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { CabinetTemplate } from "src/components/templates/CabinetTemplate";
import { Loader } from "src/components/atoms/Loader";

export const CabinetLayout: React.FC = () => (
  <CabinetTemplate title={null}>
    <Suspense
      fallback={
        <div style={{ display: "flex", justifyContent: "center", padding: "40px 0" }}>
          <Loader />
        </div>
      }
    >
      <Outlet />
    </Suspense>
  </CabinetTemplate>
);
